import { getItemFromLocalStorage } from 'utils/common';
import { GatewayResponse, Option } from './types';
import { CUSTOM_FIELDS } from './constants';

export const isChildOfMenuTransition = (
  element: HTMLElement | null,
  dropdownName: string,
) => {
  if (!element) return false;

  let parent = element.parentElement;

  while (parent) {
    if (parent.classList.contains('ui') && parent.classList.contains('selection') && parent.classList.contains('dropdown') && parent.classList.contains('active') && parent.classList.contains(`${dropdownName}`)) {
      return true;
    }
    if (parent.classList.contains('menu') && parent.classList.contains('transition')) {
      return false;
    }
    parent = parent.parentElement;
  }

  return false;
};

type UpfrontTDR = {
  paymentMethod?: string;
  paymentGateway?: string;
  tdr?: string;
  pg?: string;
  floor?: string;
  ceil?: string;
  fixedFee?: string;
};

export const validate = (isEditMode, showSlabs, enableSlabsForAll) => values => {
  const errors: UpfrontTDR = {};

  const { paymentMethod, tdr, tdrType, paymentNetwork, pg, fixedFee } = values;
  if (!isEditMode && paymentMethod.length === 0) {
    errors.paymentMethod = 'Select payment method';
  }

  // add condition for paymentNetwork

  // if (paymentGateway.length === 0) {
  //   errors.paymentGateway = 'Select payment gateway';
  // }

  if (showSlabs) {
    // PG
    if (!pg && !isEditMode && !enableSlabsForAll) errors.pg = 'Select a Gateway';
    // TDR and Fixed Fee
    if (!tdr && !fixedFee) {
      errors.tdr = "Please provide atleast one of TDR/Fixed Fee";
      errors.fixedFee = "Please provide atleast one of TDR/Fixed Fee";
    } else if (tdr || fixedFee) {
      if (tdr && tdr < 0) {
        errors.tdr = 'Enter a value greater than 0';
      } else if (tdr && tdr > 100 && tdrType === 'PERCENTAGE') {
        errors.tdr = 'TDR value must be less than 100';
      }

      if (fixedFee && fixedFee < 0) {
        errors.fixedFee = 'Enter a value greater than 0';
      }
    }
  } else if (!tdr) {
    errors.tdr = 'This is a required field';
  } else if (tdr < 0) {
    errors.tdr = 'Enter a value greater than 0';
  } else if (tdr > 100 && tdrType === 'PERCENTAGE') {
    errors.tdr = 'TDR value must be less than 100';
  }

  return errors;
};

export const prepareGatewayOptions = (data: GatewayResponse[]) => {
  const result: Option[] = [];
  data.forEach(obj => {
    if (obj.status === 'ACTIVE') {
      // set the first item as ALL
      if (result.length === 0) {
        result.push({
          key: 'ALL',
          text: 'All',
          value: 'ALL',
        });
      }
      // push the options in the result
      result.push({
        key: obj.routeId,
        text: obj.name,
        value: obj.pg,
      });
    }
  });
  return result;
};

export const findPaymenGateways = (pg: string, data: any) => {
  const result = data.find(obj => obj.pg === pg);
  return result?.name;
};

export const preparePaymentMethodOptions = (data: any) => {
  const result: Option[] = [];
  data.forEach(obj => {
    // if (obj.isActive) {
    // set the first item as ALL
    if (result.length === 0) {
      result.push({
        key: 'ALL',
        text: 'All',
        value: 'ALL',
      });
    }
    // push the options in the result
    result.push({
      key: obj.code,
      text: obj.display,
      value: obj.code,
    });
    // }
  });
  return result;
};


// export const getInitialValues = (formData: any, paymentMethods: Option[]) => {
//   const result = {
//     paymentNetwork: [],
//     paymentMethod: [],
//     tdrType: 'TDR_AMOUNT',
//     tdr: formData[0].externalUpfrontTdr, // how to determine if amount or percentage
//     // paymentGateway: [],
//   };

//   const paymentMethodsMapper = {};
//   const paymentGatewaysMapper = {};

//   formData.forEach(obj => {
//     // prepare the initialValues like this
//     paymentMethodsMapper[obj.modeCode] = true;
//     // paymentGatewaysMapper[obj.pg] = true;
//   });

//   // const pg: Option[] = gateways.filter(obj => !!paymentGatewaysMapper[obj.value]);
//   const modes: Option[] = paymentMethods.filter(obj => !!paymentMethodsMapper[obj.value]);

//   // result.paymentGateway = pg;
//   result.paymentMethod = modes;

//   return result;
// }

// [
//   {
//       "merchantId": 73002022,
//       "modeCode": 821222,
//       "externalUpfrontTdr": 49,
//       "pg": "pa_ea3seobqg",
//       "isActive": true,
//       "active": true,
//       "floor": 2,
//       "ceil": 2,
//       "fixedFee": 23,
//       "merchantExternalPMRConditionRequest": [
//           {
//               "externalUpfrontTdr": 12,
//               "greaterThanValue": 500,
//               "lessThanEqualsToValue": 23,
//               "floor": 234.56,
//               "ceil": 9999,
//               "fixedFee": 456.78,
//               "externalUpfrontTdrType": "FLAT"
//           }
//       ]
//   }
// ]

export const preparePayload = (data: any) => {
  const result: any[] = [];

  data.paymentMethod.forEach((obj) => {
    if (obj.value !== 'ALL') {
      result.push({
        merchantId: +getItemFromLocalStorage('merchantId'),
        modeCode: +obj.value,
        externalUpfrontTdr: +data.tdr,
        externalUpfrontTdrType: data.tdrType,
        pg: '',
        isActive: true,
      });
    }
  });
  return result;
}

export const preparePayloadV2 = (data: any) => {
  const result: any[] = [];

  data.paymentMethod.forEach((obj) => {
    if (obj.value !== 'ALL') {
      result.push({
        merchantId: +getItemFromLocalStorage('merchantId'),
        modeCode: +obj.value,
        externalUpfrontTdr: +data.tdr,
        externalUpfrontTdrType: data.tdrType,
        floor: +data.floor,
        ceil: +data.ceil,
        fixedFee: +data.fixedFee,
        active: true,
        pg: data.pg,
        isActive: true,
      });
    }
  });
  return result;
}

export const getUpfrontTDRTooltipText = (paymentMode: string) => {
  switch (paymentMode) {
    case 'UPI':
      return 'Select the UPI type, like UPI, FLASH UPI or both to add Upfront TDR.';
    case 'CORPORATE_CREDIT_CARD':
    case 'NET_BANKING':
      return 'Select the Banks. If you want to select all banks, select ALL.';
    case 'DEBIT_CARD':
    case 'CREDIT_CARD':
      return 'Select the Card Network, then corresponding payment methods. Else select ALL.';
    case 'Wallet':
      return 'Select the Wallet/s. If you want to select all Wallets, select ALL.';
    case 'PAY_LATER':
      return 'Select the Paylater Option/s. If you want to select all options, select ALL';
    case 'CARDLESS_EMI':
    case 'DEBIT_CARD_EMI':
    case 'CREDIT_CARD_EMI':
      return 'Select the EMI Option/s. If you want to select all EMI options, select ALL.';
    default: return '';
  }
};

export const getSelectedCount = (values = []) => values?.filter(obj => obj.key !== 'ALL').length;

export const getPGDropdownData = (data) => {
  return data.map(obj => ({ key: obj.routeId, value: obj.pg, text: obj.name }));
}

export const filterFormData = formData => formData.map(
  obj => Object.keys(obj).reduce((acc, key) => {
    if (typeof obj[key] !== 'function' && !CUSTOM_FIELDS.includes(key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {}),
).filter(obj => Object.keys(obj).length > 0);

export const filterOutAllOption = options => options.filter(obj => obj.key !== 'ALL');